export default "__VITE_ASSET__B5XYwnFE__"